import { setMeasurer } from "./core/text";

// One text measurer for the canvas, fitting, preflight and every export
// (plan phase 5): a canvas 2D context with the node's font. Without a canvas
// (server, some tests) the core falls back to a deterministic estimate.
let context;
function canvasMeasure(text, style) {
  if (context === undefined) {
    try {
      context = typeof document !== "undefined" ? document.createElement("canvas").getContext("2d") : null;
    } catch (_) {
      context = null;
    }
  }
  if (!context || typeof context.measureText !== "function") return text.length * style.fontSize * 0.53 + Math.max(0, text.length - 1) * (style.letterSpacing || 0);
  context.font = `${style.fontStyle || "normal"} ${style.fontWeight || 400} ${style.fontSize}px ${style.fontFamily}`;
  return context.measureText(text).width + Math.max(0, text.length - 1) * (style.letterSpacing || 0);
}
setMeasurer(canvasMeasure);

export { textLines, textWidth, textRuns } from "./core/text";
